var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenterVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12C17 11.6548 17.2798 11.375 17.625 11.375H19.5C19.8452 11.375 20.125 11.6548 20.125 12C20.125 12.3452 19.8452 12.625 19.5 12.625H17.625C17.2798 12.625 17 12.3452 17 12Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.875 12C3.875 11.6548 4.15482 11.375 4.5 11.375H6.375C6.72018 11.375 7 11.6548 7 12C7 12.3452 6.72018 12.625 6.375 12.625H4.5C4.15482 12.625 3.875 12.3452 3.875 12Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 12C10.125 11.6548 10.4048 11.375 10.75 11.375H13.25C13.5952 11.375 13.875 11.6548 13.875 12C13.875 12.3452 13.5952 12.625 13.25 12.625H10.75C10.4048 12.625 10.125 12.3452 10.125 12Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6.375C17.6904 6.375 18.25 6.93464 18.25 7.625V16.375C18.25 17.0654 17.6904 17.625 17 17.625H13.875C13.1846 17.625 12.625 17.0654 12.625 16.375V7.625C12.625 6.93464 13.1846 6.375 13.875 6.375H17ZM17 16.375V7.625H13.875V16.375H17Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 5.75C5.75 5.05964 6.30964 4.5 7 4.5H10.125C10.8154 4.5 11.375 5.05964 11.375 5.75V18.25C11.375 18.9404 10.8154 19.5 10.125 19.5H7C6.30964 19.5 5.75 18.9404 5.75 18.25V5.75ZM10.125 5.75H7V18.25H10.125V5.75Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenterVertical);
export default __webpack_public_path__ + "static/media/align-center-vertical.fdf49b26931a3d3fad9163487896919e.svg";
export { ForwardRef as ReactComponent };